// Traduce gli errori tecnici (Firestore, Firebase Storage, Auth, rete) in messaggi
// comprensibili per l'utente finale. Non mostrare mai err.message grezzo in interfaccia.
//
// Uso tipico:
//   } catch (err) { addToast(messaggioErrore(err), "error"); }
//
// Con contesto opzionale (consigliato dove l'azione non è ovvia dal resto della UI):
//   } catch (err) { addToast(messaggioErrore(err, "salvare il SAL"), "error"); }
//   → "Impossibile salvare il SAL: non hai i permessi necessari per questa operazione."

const MAPPA_CODICI = {
  // Firestore
  "permission-denied": "operazione non consentita: la sezione è in sola lettura con il piano attuale, oppure il tuo ruolo non ha questo permesso",
  "unavailable": "il servizio non è raggiungibile al momento — controlla la connessione e riprova",
  "not-found": "l'elemento non esiste più (potrebbe essere stato eliminato da un altro utente)",
  "already-exists": "esiste già un elemento con questi dati",
  "resource-exhausted": "limite del servizio raggiunto, riprova tra qualche minuto",
  "deadline-exceeded": "l'operazione ha impiegato troppo tempo, riprova",
  "cancelled": "operazione annullata",
  "unauthenticated": "sessione scaduta — effettua di nuovo l'accesso",
  "invalid-argument": "alcuni dati inseriti non sono validi",
  "failed-precondition": "l'operazione non è consentita nello stato attuale dei dati",

  // Firebase Storage
  "storage/unauthorized": "non hai i permessi per caricare o leggere questo file",
  "storage/canceled": "caricamento annullato",
  "storage/quota-exceeded": "spazio di archiviazione esaurito — contatta l'amministratore",
  "storage/retry-limit-exceeded": "caricamento non riuscito, controlla la connessione e riprova",
  "storage/network-request-failed": "connessione assente o instabile durante il caricamento",
  "storage/unknown": "servizio di archiviazione file non disponibile al momento",

  // Auth (residuali, oltre ai casi già gestiti in LoginPage)
  "auth/requires-recent-login": "per sicurezza, esegui di nuovo l'accesso prima di continuare",
  "auth/network-request-failed": "connessione assente o instabile",
  // W447: password e link via email
  "auth/too-many-requests": "troppi tentativi: riprova tra qualche minuto",
  "auth/weak-password": "password troppo debole: almeno 8 caratteri",
  "auth/expired-action-code": "il link è scaduto: chiedine uno nuovo",
  "auth/invalid-action-code": "link non valido o già usato",
  "auth/wrong-password": "la password non è corretta",
  "auth/invalid-credential": "credenziali non corrette",
};

function daFrammentoTestuale(raw) {
  if (raw.includes("network") || raw.includes("failed to fetch") || raw.includes("offline")) {
    return "connessione assente o instabile — controlla la rete e riprova";
  }
  if (raw.includes("permission") || raw.includes("insufficient")) {
    return "operazione non consentita: la sezione è in sola lettura con il piano attuale, oppure il tuo ruolo non ha questo permesso";
  }
  if (raw.includes("quota")) {
    return "limite del servizio raggiunto, riprova tra qualche minuto";
  }
  if (raw.includes("timeout")) {
    return "l'operazione ha impiegato troppo tempo, riprova";
  }
  return null;
}

/**
 * @param {any} err - l'oggetto errore catturato (Firebase o JS generico)
 * @param {string} [azione] - descrizione facoltativa dell'azione fallita, es. "salvare il SAL"
 * @returns {string} messaggio pronto per essere mostrato all'utente (toast, banner, ecc.)
 */
export function messaggioErrore(err, azione) {
  const code = err?.code || "";
  const raw = (err?.message || String(err || "")).toLowerCase();

  let spiegazione = MAPPA_CODICI[code] || daFrammentoTestuale(raw);
  if (!spiegazione) {
    spiegazione = "si è verificato un errore imprevisto — riprova; se il problema persiste, contatta il supporto";
  }

  const prima = spiegazione.charAt(0).toUpperCase() + spiegazione.slice(1);
  return azione ? `Impossibile ${azione}: ${spiegazione}.` : `${prima}.`;
}
